import React, { useState, useEffect } from 'react';
import { useToast } from '../../components/Toast';
import { colors } from '../../styles/theme';
import { logError } from '../../utils/logError';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const token = () => localStorage.getItem('access_token');
const headers = () => ({ 'Authorization': `Bearer ${token()}`, 'Content-Type': 'application/json' });

const fcColor = (v) => v < 30 ? '#28a745' : v > 35 ? '#dc3545' : '#fd7e14';

export default function FiyatSimulasyonuPage() {
  const [tab, setTab] = useState('fiyat'); // fiyat | malzeme
  const toast = useToast();
  const [recipes, setRecipes] = useState([]);
  const [malzemeler, setMalzemeler] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fiyat simülasyonu
  const [seciliRecipe, setSeciliRecipe] = useState('');
  const [yeniFiyat, setYeniFiyat] = useState('');
  const [fiyatSonuc, setFiyatSonuc] = useState(null);
  const [fiyatLoading, setFiyatLoading] = useState(false);

  // Malzeme simülasyonu
  const [seciliMalzeme, setSeciliMalzeme] = useState('');
  const [yeniMalzemeFiyat, setYeniMalzemeFiyat] = useState('');
  const [malzemeSonuc, setMalzemeSonuc] = useState(null);
  const [malzemeLoading, setMalzemeLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const [rRes, mRes] = await Promise.all([
          fetch(`${API}/api/recipes?tip=TABAK&durum=AKTIF`, { headers: headers() }),
          fetch(`${API}/api/malzemeler?aktif=true`, { headers: headers() })
        ]);
        if (rRes.ok) setRecipes(await rRes.json());
        if (mRes.ok) setMalzemeler(await mRes.json());
      } catch (err) { logError(err); }
      setLoading(false);
    };
    load();
  }, []);

  const fiyatSimule = async () => {
    if (!seciliRecipe || !yeniFiyat) return;
    setFiyatLoading(true);
    try {
      const res = await fetch(`${API}/api/menu-muhendisligi/simulasyon/fiyat`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({ recipe_id: Number(seciliRecipe), yeni_fiyat: Number(yeniFiyat) })
      });
      if (res.ok) setFiyatSonuc(await res.json());
      else { const err = await res.json(); toast.error(err.detail || 'Hata'); }
    } catch (err) { toast.error(err.message); }
    setFiyatLoading(false);
  };

  const malzemeSimule = async () => {
    if (!seciliMalzeme || !yeniMalzemeFiyat) return;
    setMalzemeLoading(true);
    try {
      const res = await fetch(`${API}/api/menu-muhendisligi/simulasyon/malzeme`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({ malzeme_id: Number(seciliMalzeme), yeni_fiyat: Number(yeniMalzemeFiyat) })
      });
      if (res.ok) setMalzemeSonuc(await res.json());
      else { const err = await res.json(); toast.error(err.detail || 'Hata'); }
    } catch (err) { toast.error(err.message); }
    setMalzemeLoading(false);
  };

  if (loading && recipes.length === 0) return <div style={{ padding: 40, textAlign: 'center' }}>Yükleniyor...</div>;

  return (
    <div style={{ padding: '24px 28px', maxWidth: 1200 }}>
      <h1 style={{ margin: '0 0 4px', fontSize: 22, color: colors.textPrimary }}>💰 Fiyat Simülasyonu</h1>
      <p style={{ margin: '0 0 20px', color: colors.textTertiary, fontSize: 13 }}>Fiyat ve maliyet değişikliklerinin etkisini önceden görün</p>

      {/* Tab seçimi */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 24 }}>
        {[
          { key: 'fiyat', label: '🏷️ Satış Fiyatı Simülasyonu', desc: '"Bu ürünün fiyatını artırsam?"' },
          { key: 'malzeme', label: '📦 Malzeme Fiyatı Simülasyonu', desc: '"Bu malzeme zamlanırsa?"' }
        ].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '12px 20px', border: `1px solid ${colors.border}`, cursor: 'pointer',
            background: tab === t.key ? '#d32f2f' : '#fff',
            color: tab === t.key ? '#fff' : '#666',
            borderRadius: t.key === 'fiyat' ? '8px 0 0 8px' : '0 8px 8px 0',
            fontWeight: tab === t.key ? 'bold' : 'normal', fontSize: 13
          }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ─── SATIŞ FİYATI SİMÜLASYONU ─── */}
      {tab === 'fiyat' && (
        <div>
          <div style={{ background: colors.surface, borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 20 }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 15 }}>Senaryo: Satış fiyatı değişikliği</h3>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div style={{ flex: 2, minWidth: 200 }}>
                <label style={{ fontSize: 12, color: colors.textSecondary, display: 'block', marginBottom: 4 }}>Ürün</label>
                <select value={seciliRecipe} onChange={e => setSeciliRecipe(e.target.value)}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: `1px solid ${colors.border}`, fontSize: 13 }}>
                  <option value="">Seçin...</option>
                  {/* Yalnız satış fiyatı tanımlı (>0) reçeteler: satış fiyatı olmayan
                      bir kalemde "satış fiyatını X yap" simülasyonu anlamsız (mevcut=0). */}
                  {recipes.filter(r => (r.pos_satis_fiyati || 0) > 0).map(r => (
                    <option key={r.id} value={r.id}>
                      {r.ad} (₺{r.pos_satis_fiyati})
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1, minWidth: 120 }}>
                <label style={{ fontSize: 12, color: colors.textSecondary, display: 'block', marginBottom: 4 }}>Yeni Fiyat (₺)</label>
                <input type="number" value={yeniFiyat} onChange={e => setYeniFiyat(e.target.value)}
                  placeholder="Ör: 85" step="0.5"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: `1px solid ${colors.border}`, fontSize: 13 }} />
              </div>
              <button onClick={fiyatSimule} disabled={fiyatLoading || !seciliRecipe || !yeniFiyat}
                style={{
                  padding: '8px 20px', borderRadius: 6, border: 'none', background: '#d32f2f',
                  color: '#fff', cursor: 'pointer', fontWeight: 'bold', fontSize: 13, opacity: (!seciliRecipe || !yeniFiyat) ? 0.5 : 1
                }}>
                {fiyatLoading ? 'Hesaplanıyor...' : 'Simüle Et'}
              </button>
            </div>
          </div>

          {/* Sonuç */}
          {fiyatSonuc && (
            <div style={{ background: colors.surface, borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 16px', fontSize: 15 }}>{fiyatSonuc.urun} — Simülasyon Sonucu</h3>

              <div style={{ display: 'flex', gap: 20, marginBottom: 20, flexWrap: 'wrap' }}>
                {/* Mevcut */}
                <div style={{ flex: 1, minWidth: 250, background: colors.backgroundAlt, borderRadius: 8, padding: 16 }}>
                  <h4 style={{ margin: '0 0 12px', fontSize: 13, color: colors.textTertiary }}>📌 Mevcut Durum</h4>
                  <table style={{ width: '100%', fontSize: 13 }}>
                    <tbody>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Satış Fiyatı</td><td style={{ padding: 4, textAlign: 'right', fontWeight: 'bold' }}>₺{fiyatSonuc.mevcut.satis_fiyati}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Porsiyon Maliyeti</td><td style={{ padding: 4, textAlign: 'right' }}>₺{fiyatSonuc.mevcut.porsiyon_maliyeti}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Katkı Payı</td><td style={{ padding: 4, textAlign: 'right', fontWeight: 'bold' }}>₺{fiyatSonuc.mevcut.katki_payi}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Food Cost</td><td style={{ padding: 4, textAlign: 'right', color: fcColor(fiyatSonuc.mevcut.food_cost) }}>%{fiyatSonuc.mevcut.food_cost?.toFixed(1)}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Kâr Marjı</td><td style={{ padding: 4, textAlign: 'right' }}>%{fiyatSonuc.mevcut.kar_marji?.toFixed(1)}</td></tr>
                    </tbody>
                  </table>
                </div>

                {/* Simülasyon */}
                <div style={{ flex: 1, minWidth: 250, background: '#e8f5e9', borderRadius: 8, padding: 16 }}>
                  <h4 style={{ margin: '0 0 12px', fontSize: 13, color: '#2e7d32' }}>🔮 Simülasyon</h4>
                  <table style={{ width: '100%', fontSize: 13 }}>
                    <tbody>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Satış Fiyatı</td><td style={{ padding: 4, textAlign: 'right', fontWeight: 'bold' }}>₺{fiyatSonuc.simulasyon.satis_fiyati}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Porsiyon Maliyeti</td><td style={{ padding: 4, textAlign: 'right' }}>₺{fiyatSonuc.simulasyon.porsiyon_maliyeti}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Katkı Payı</td><td style={{ padding: 4, textAlign: 'right', fontWeight: 'bold', color: '#2e7d32' }}>₺{fiyatSonuc.simulasyon.katki_payi} ({fiyatSonuc.simulasyon.katki_payi_degisim_pct > 0 ? '+' : ''}{fiyatSonuc.simulasyon.katki_payi_degisim_pct}%)</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Food Cost</td><td style={{ padding: 4, textAlign: 'right', color: fcColor(fiyatSonuc.simulasyon.food_cost) }}>%{fiyatSonuc.simulasyon.food_cost?.toFixed(1)}</td></tr>
                      <tr><td style={{ padding: 4, color: colors.textSecondary }}>Kâr Marjı</td><td style={{ padding: 4, textAlign: 'right' }}>%{fiyatSonuc.simulasyon.kar_marji?.toFixed(1)}</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Tahmini etki */}
              <div style={{
                background: '#fff3e0', borderRadius: 8, padding: 16, display: 'flex',
                gap: 20, alignItems: 'center', flexWrap: 'wrap'
              }}>
                <div>
                  <div style={{ fontSize: 12, color: '#e65100' }}>Aylık Tahmini Ek Kâr</div>
                  <div style={{ fontSize: 22, fontWeight: 'bold', color: fiyatSonuc.simulasyon.aylik_tahmini_ek_kar >= 0 ? '#2e7d32' : '#c62828' }}>
                    {fiyatSonuc.simulasyon.aylik_tahmini_ek_kar >= 0 ? '+' : ''}₺{fiyatSonuc.simulasyon.aylik_tahmini_ek_kar?.toLocaleString('tr-TR')}
                  </div>
                  <div style={{ fontSize: 11, color: colors.textTertiary }}>Son 30 gün satışına göre ({fiyatSonuc.simulasyon.son_30_gun_satis} adet)</div>
                </div>
                <div style={{ fontSize: 13, color: '#e65100', flex: 1 }}>
                  ⚠️ {fiyatSonuc.risk_notu}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ─── MALZEME FİYATI SİMÜLASYONU ─── */}
      {tab === 'malzeme' && (
        <div>
          <div style={{ background: colors.surface, borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 20 }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 15 }}>Senaryo: Malzeme fiyatı değişikliği</h3>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
              <div style={{ flex: 2, minWidth: 200 }}>
                <label style={{ fontSize: 12, color: colors.textSecondary, display: 'block', marginBottom: 4 }}>Malzeme</label>
                <select value={seciliMalzeme} onChange={e => setSeciliMalzeme(e.target.value)}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: `1px solid ${colors.border}`, fontSize: 13 }}>
                  <option value="">Seçin...</option>
                  {malzemeler.map(m => (
                    <option key={m.id} value={m.id}>
                      {m.ad} {m.fiyat ? `(₺${m.fiyat}/${m.birim})` : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1, minWidth: 120 }}>
                <label style={{ fontSize: 12, color: colors.textSecondary, display: 'block', marginBottom: 4 }}>Yeni Fiyat (₺)</label>
                <input type="number" value={yeniMalzemeFiyat} onChange={e => setYeniMalzemeFiyat(e.target.value)}
                  placeholder="Ör: 350" step="1"
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: `1px solid ${colors.border}`, fontSize: 13 }} />
              </div>
              <button onClick={malzemeSimule} disabled={malzemeLoading || !seciliMalzeme || !yeniMalzemeFiyat}
                style={{
                  padding: '8px 20px', borderRadius: 6, border: 'none', background: '#d32f2f',
                  color: '#fff', cursor: 'pointer', fontWeight: 'bold', fontSize: 13, opacity: (!seciliMalzeme || !yeniMalzemeFiyat) ? 0.5 : 1
                }}>
                {malzemeLoading ? 'Hesaplanıyor...' : 'Simüle Et'}
              </button>
            </div>
          </div>

          {/* Malzeme sonuç */}
          {malzemeSonuc && (
            <div style={{ background: colors.surface, borderRadius: 10, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 4px', fontSize: 15 }}>
                {malzemeSonuc.malzeme}: ₺{malzemeSonuc.mevcut_fiyat} → ₺{malzemeSonuc.yeni_fiyat}
              </h3>
              <p style={{ margin: '0 0 16px', color: colors.textTertiary, fontSize: 13 }}>
                {malzemeSonuc.etkilenen_urun_sayisi} ürün etkileniyor
              </p>

              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
                <thead>
                  <tr style={{ background: colors.backgroundAlt }}>
                    <th style={{ padding: '8px 12px', textAlign: 'left' }}>Ürün</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Satış Fiyatı</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Mevcut Maliyet</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Yeni Maliyet</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Fark</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Mevcut FC</th>
                    <th style={{ padding: '8px', textAlign: 'right' }}>Yeni FC</th>
                  </tr>
                </thead>
                <tbody>
                  {malzemeSonuc.etkilenen_urunler.map((u, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '8px 12px', fontWeight: 500 }}>{u.urun}</td>
                      <td style={{ padding: 8, textAlign: 'right' }}>₺{u.satis_fiyati}</td>
                      <td style={{ padding: 8, textAlign: 'right' }}>₺{u.mevcut_maliyet}</td>
                      <td style={{ padding: 8, textAlign: 'right', fontWeight: 'bold' }}>₺{u.yeni_maliyet}</td>
                      <td style={{ padding: 8, textAlign: 'right', color: u.maliyet_degisim > 0 ? '#dc3545' : '#28a745', fontWeight: 'bold' }}>
                        {u.maliyet_degisim > 0 ? '+' : ''}₺{u.maliyet_degisim}
                      </td>
                      <td style={{ padding: 8, textAlign: 'right', color: fcColor(u.mevcut_food_cost) }}>%{u.mevcut_food_cost?.toFixed(1)}</td>
                      <td style={{ padding: 8, textAlign: 'right', color: fcColor(u.yeni_food_cost) }}>%{u.yeni_food_cost?.toFixed(1)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
